import request from '@/utils/request';

/**
 * 用户服务 - 处理用户相关API请求
 */
class UserService {
  /**
   * 获取用户信息
   * @returns {Promise} 用户信息响应
   */
  getUserInfo() {
    return request.get('/api/auth/user/info');
  }

  /**
   * 更新用户信息
   * @param {Object} data - 用户信息数据
   * @returns {Promise} 更新响应
   */
  updateUserInfo(data) {
    return request.put('/api/auth/user/info', data);
  }

  /**
   * 更新用户头像
   * @param {FormData} formData - 包含头像文件的表单数据
   * @returns {Promise} 上传响应
   */
  updateAvatar(formData) {
    return request.post('/api/auth/user/avatar', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }
  // 注册方法
  register(userData) {
    return request.post(`/api/auth/register`, userData)
      .then(data => {
        
        // 检查是否成功，如果不成功则抛出错误
        if (!data.success) {
          const error = new Error(data.message || '注册失败');
          error.code = data.code;
          error.data = data;
          throw error;
        }
        
        // 处理成功响应，提取用户令牌信息
        if (data.access_token) {
          // 存储令牌到本地存储
          const userData = {
            uid: data.user.uid,
            username: data.user.username,
            access_token: data.access_token,
            refresh_token: data.refresh_token,
            token_type: data.token_type
          };
          localStorage.setItem('user', JSON.stringify(userData));
        }
        
        return data;
      });
  }
    // 登录方法
    login(user) {
      return request.post(`/api/auth/login`, user)
        .then(data => {
          
          // 检查是否成功，如果不成功则抛出错误
          if (!data.success) {
            const error = new Error(data.message || '登录失败');
            error.code = data.code;
            error.data = data;
            throw error;
          }
          
          // 处理成功响应，提取用户令牌信息
          if (data.access_token) {
            // 存储令牌到本地存储
            const userData = {
              uid: data.user.uid,
              username: data.user.username,
              access_token: data.access_token,
              refresh_token: data.refresh_token,
              token_type: data.token_type
            };
            localStorage.setItem('user', JSON.stringify(userData));
          }
          
          return data;
        });
    }
    // 登出方法
    logout() {
      // 调用后端的登出API
      const user = request.getCurrentUser();
      if (user && user.access_token) {
        request.post(`/api/auth/logout`, {}
        ).catch(() => {
          // 即使后端登出失败，也要确保前端已登出
          console.log('前端已登出');
        });
      }
      
      // 清除本地存储
      localStorage.removeItem('user');
    }
      // 发送短信验证码
  sendSmsCode(data) {
    return request.post(`/api/auth/send_sms_code`, data)
  }
  /**
   * 检查用户VIP状态
   * @returns {Promise} VIP状态响应
   */
  checkVipStatus() {
    return request.get('/api/auth/user/check_vip');
  }

    // 应用启动时验证令牌
    // verifyTokenOnStartup() {
    //   const user = this.getCurrentUser();
    //   if (!user || !user.access_token) {
    //     return Promise.reject({ message: '无用户令牌' });
    //   }
      
    //   return authAxios.post(`${API_URL}/verify_token`, { access_token: user.access_token })
    //     .then(response => {
    //       const data = response.data;
          
    //       if (!data.success) {
    //         throw new Error(data.message || '令牌验证失败');
    //       }
          
    //       return data;
    //     });
    // }

    // 举报用户
    reportUser(data) {
      return request.post(`/api/auth/report_user`, data);
    }
    
    // 为了兼容旧代码，添加别名
    reportUserService(data) {
      return this.reportUser(data);
    }

    // 从auth.js迁移过来的方法 ===============

    // 获取当前登录用户
    getCurrentUser() {
      return request.getCurrentUser();
    }
    
    // 刷新访问令牌
    refreshToken() {
      const user = JSON.parse(localStorage.getItem('user'));
      console.log('刷新令牌',user);
      if (!user || !user.refresh_token) {
        return Promise.reject({ 
          message: '无刷新令牌',
          isRefreshTokenError: true
        });
      }
      
      // 确保带上前缀的完整URL
      return request.post('/api/auth/refresh', { refresh_token: user.refresh_token })
        .then(data => {
          // 更新本地存储中的访问令牌
          user.access_token = data.access_token;
          
          // 如果后端同时返回了新的刷新令牌，也一并更新
          if (data.refresh_token) {
            user.refresh_token = data.refresh_token;
          }
          
          localStorage.setItem('user', JSON.stringify(user));
          return data;
        })
        .catch(error => {
          console.log('刷新令牌捕获到错误:', error);
          
          // 特殊处理刷新令牌过期的情况
          if (error.response && error.response.status === 401) {
            // 包装错误，标记为刷新令牌错误
            const refreshTokenError = new Error(
              error.response?.data?.message || '刷新令牌已过期或无效'
            );
            refreshTokenError.isRefreshTokenError = true;
            throw refreshTokenError;
          }
          
          // 处理其他HTTP错误
          if (error.response) {
            const errorMsg = error.response.data?.message || `服务器返回错误 (${error.response.status})`;
            const refreshTokenError = new Error(errorMsg);
            refreshTokenError.isRefreshTokenError = true;
            throw refreshTokenError;
          }
          
          // 处理网络错误或其他错误
          const networkError = new Error(error.message || '网络错误，无法刷新令牌');
          networkError.isRefreshTokenError = true;
          throw networkError;
        });
    }

    // 检查用户是否已登录
    isAuthenticated() {
      const user = this.getCurrentUser();
      return !!user && !!user.access_token;
    }

    // 获取授权头部
    getAuthorizationHeader() {
      const user = this.getCurrentUser();
      return user && user.access_token ? `Bearer ${user.access_token}` : '';
    }

    // 验证当前令牌是否有效
    async validateToken() {
      console.group('%c令牌验证', 'background:#0088ff; color:#fff; padding:4px;');
      console.log('开始验证令牌 - 时间:', new Date().toISOString());
      
      // 读取本地存储的用户信息
      const userStr = localStorage.getItem('user');
      console.log('localStorage中的user数据:', userStr ? '存在' : '不存在');
      
      if (userStr) {
        try {
          const userData = JSON.parse(userStr);
          console.log('用户数据解析成功:', { 
            uid: userData.uid, 
            username: userData.username, 
            hasAccessToken: !!userData.access_token,
            tokenLength: userData.access_token ? userData.access_token.length : 0
          });
        } catch (e) {
          console.error('解析用户数据失败:', e);
        }
      }
      
      try {
        // 使用新的验证接口
        console.log('发送请求到 /auth/validate-auth');
        const data = await request.get('/api/auth/validate-auth');
        console.log('验证接口响应成功:', data);
        
        // 记录网络请求的详细信息
        if (window.performance && window.performance.getEntriesByType) {
          const resources = window.performance.getEntriesByType('resource');
          const authRequest = resources.find(r => r.name.includes('/auth/validate-auth'));
          if (authRequest) {
            console.log('请求性能数据:', {
              duration: authRequest.duration + 'ms',
              startTime: new Date(performance.timeOrigin + authRequest.startTime).toISOString(),
              endTime: new Date(performance.timeOrigin + authRequest.responseEnd).toISOString()
            });
          }
        }
        
        console.groupEnd();
        return {
          valid: true,
          user: {
            uid: data.user_id,
            username: data.username
          }
        };
      } catch (error) {
        console.error("令牌验证失败:", error);
        
        // 更详细的错误信息
        if (error.response) {
          console.log('HTTP错误状态码:', error.response.status);
          console.log('错误响应数据:', error.response.data);
        } else if (error.request) {
          console.log('请求已发送但未收到响应:', error.request);
        } else {
          console.log('请求构建阶段出错:', error.message);
        }
        
        // 如果是401错误或明确的认证错误，返回无效
        if (error.code === 401 || error.isAuthError) {
          console.log('认证错误，令牌无效');
          console.groupEnd();
          return {
            valid: false,
            reason: error.message || "认证失败"
          };
        }
        // 如果是网络问题，假定令牌仍然有效，避免错误登出
        console.log('网络或其他错误，假定令牌有效');
        console.groupEnd();
        return {
          valid: true,
          networkError: true
        };
      }
    }
}

export default new UserService(); 